import { Schema } from '@/interfaces/schema';
import { SchemaResource, schemaResource } from '@/resources/schema.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł schem
 *
 * @export
 * @class SchemaModule
 * @extends {EntityModule<Schema, SchemaResource>}
 */
export class SchemaModule extends EntityModule<Schema, SchemaResource> {
  constructor() {
    super(schemaResource);
  }
}

export default new SchemaModule();
